import styled from 'styled-components/macro';
import { useHistory, useLocation } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, Divider, Collapse } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import DrawerItem from './MainDrawerItem';
import { setItem } from 'storage';
import { KEY_PATHNAME } from 'utility/lookup';
import { produce } from 'utility/general';
import { version } from 'utility/version';
import { getCombineRoute } from 'utility/route';
import { getMenuAction } from 'utility/menuLookup';
import { setGlobal } from 'store/global/reducer';
const SDrawerLayout = styled.div`
    padding-top: 52px;
`;

const SLayout = styled.div`
    display: flex;
    height: 100%;
`;

const drawerWidth = 255;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        // transition: theme.transitions.create('width', {
        //     easing: theme.transitions.easing.sharp,
        //     duration: theme.transitions.duration.enteringScreen,
        // }),
    },
    drawerClose: {
        // transition: theme.transitions.create('width', {
        //     easing: theme.transitions.easing.sharp,
        //     duration: theme.transitions.duration.leavingScreen,
        // }),
        overflowX: 'hidden',
        width: 48,
        // [theme.breakpoints.up('sm')]: {
        //     width: theme.spacing(9) + 1,
        // },
    },
    content: {
        flexGrow: 1,
    },
    listSize: {
        fontWeight: 'bold',
        fontSize: '14px',
    },
}));

const NavigationDrawer = ({ children }) => {
    const isShowDrawer = useSelector((state) => state.global.isShowDrawer);
    const role = useSelector((state) => state.user.role);
    const history = useHistory();
    const location = useLocation();
    const isLogin = useSelector((state) => state.user.isLogin);
    const [opens, setOpens] = useState([]);
    const [backupOpens, setBackupOpens] = useState([]);
    const classes = useStyles();
    const menuData = useSelector((state) => state.menu);

    const dispatch = useDispatch();

    const backendVersion = useSelector((state) => state.global.backendVersion ?? '-');

    // initialize default open tabs
    useEffect(() => {
        const currentRoute = location.pathname.split('/')?.[1];

        if (currentRoute === 'applications' || currentRoute === 'post-approval-document') {
            opens.push(`/${currentRoute}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // handle expand status when menu hide and show
    useEffect(() => {
        if (!isShowDrawer) {
            setBackupOpens([...opens]);
            setOpens([]);
        } else {
            setOpens([...backupOpens, ...opens]);
            setBackupOpens([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isShowDrawer]);

    const toggleMenu = (url) => {
        setOpens(
            produce((draft) => {
                const index = draft.indexOf(url);
                if (index !== -1) {
                    draft.splice(index, 1);
                } else {
                    draft.push(url);
                }
            }),
        );
    };

    const isTabOpen = (path) => {
        return !!opens.find((item) => item === path);
    };

    if (!isLogin) {
        return <main className={classes.content}>{children}</main>;
    }

    const combineRoutes = getCombineRoute(menuData, role);

    return (
        <SLayout>
            <Drawer
                variant="permanent"
                className={clsx(
                    classes.drawer,
                    {
                        [classes.drawerOpen]: isShowDrawer,
                        [classes.drawerClose]: !isShowDrawer,
                    },
                    'custom-drawer',
                )}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: isShowDrawer,
                        [classes.drawerClose]: !isShowDrawer,
                    }),
                }}
            >
                <SDrawerLayout>
                    <List>
                        {combineRoutes
                            .filter((item) => {
                                return item?.showInRoles?.includes(role) || item?.showInRoles?.includes('all');
                            })
                            .filter((item) => item.isLoginRequired === isLogin)
                            .map((route, index) => {
                                if (route.hiddenInDrawer) {
                                    return null;
                                }

                                return (
                                    <div
                                        key={route.path}
                                        onClick={() => {
                                            if (!route.subRoute?.length) {
                                                dispatch(
                                                    setGlobal({
                                                        isDetailBack: false,
                                                    }),
                                                );
                                                setItem(KEY_PATHNAME, `${route.path}`);
                                            }
                                        }}
                                    >
                                        <DrawerItem
                                            route={route}
                                            isTabOpen={isTabOpen(route.path)}
                                            onListToggleOpen={() => toggleMenu(route.path)}
                                        />
                                        {route.subRoute?.length >= 1 && (
                                            <Collapse
                                                in={!!opens.find((item) => item === route.path)}
                                                timeout="auto"
                                                unmountOnExit
                                                style={{ paddingLeft: 20 }}
                                            >
                                                <List component="div" disablePadding>
                                                    {route.subRoute
                                                        .filter(
                                                            (item) =>
                                                                item?.showInRoles?.includes(role) ||
                                                                item?.showInRoles?.includes('all'),
                                                        )
                                                        .filter((item) => {
                                                            return !item.hiddenInDrawer;
                                                        })
                                                        .map((subRoute, index) => {
                                                            return (
                                                                <ListItem
                                                                    button
                                                                    dense
                                                                    selected={
                                                                        location.pathname ===
                                                                        `${route.path}${subRoute.path}`
                                                                    }
                                                                    key={`${subRoute.path}-${index}`}
                                                                    onClick={() => {
                                                                        //
                                                                        dispatch(
                                                                            setGlobal({
                                                                                isDetailBack: false,
                                                                            }),
                                                                        );

                                                                        // if action is provided, skip route change
                                                                        const customAction = getMenuAction(
                                                                            `${route.path}${subRoute.path}`,
                                                                        );

                                                                        if (customAction) {
                                                                            return customAction();
                                                                        }

                                                                        setItem(
                                                                            KEY_PATHNAME,
                                                                            `${route.path}${subRoute.path}`,
                                                                        );

                                                                        history.push(`${route.path}${subRoute.path}`);
                                                                    }}
                                                                >
                                                                    <ListItemText
                                                                        primary={subRoute?.getName?.() ?? subRoute.name}
                                                                        style={{ color: 'rgba(0,0,0,0.7)' }}
                                                                        className={classes.listSize}
                                                                    />
                                                                </ListItem>
                                                            );
                                                        })}
                                                </List>
                                            </Collapse>
                                        )}
                                    </div>
                                );
                            })}
                    </List>
                    <Divider />
                    {isShowDrawer && (
                        <div style={{ padding: 15, fontWeight: 'bold' }}>
                            <div>FN Version: v{version}</div>
                            <div style={{marginTop: 10}} >BN Version: {backendVersion}</div>
                        </div>
                    )}
                </SDrawerLayout>
            </Drawer>
            <main className={classes.content}>{children}</main>
        </SLayout>
    );
};

export default NavigationDrawer;
